import { EEvent as DBEEvent } from '@pushflow/database/prisma/types/clickhouse'

export const EEvent = DBEEvent
export type EEvent = (typeof DBEEvent)[keyof typeof DBEEvent]
